<template>
	<div class="content-main">
		<!-- 基本信息 -->
		<template v-if="currentTab === '0'">
			<el-row>
				<el-col :span="10">
					<span class="label">国别/地区：</span>
					{{ baseForm.nationality }}
				</el-col>
				<el-col :span="10">
					<span class="label">负责人：</span>
					{{ baseForm.principal }}
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<span class="label">注册资本币种：</span>
					{{ baseForm.currency }}
				</el-col>
				<el-col :span="10">
					<span class="label">注册资本：</span>
					{{ baseForm.assets ? baseForm.assets + ' 万元' : '' }}
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<span class="label">信息申报负责人：</span>
					{{ baseForm.declarant }}
				</el-col>
				<el-col :span="10">
					<span class="label">成立时间：</span>
					{{ baseForm.foundDate }}
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10" class="flex">
					<span class="label">所属行业：</span>
					{{ baseForm.industryName }}
				</el-col>
				<el-col :span="10">
					<span class="label">经济性质代码：</span>
					{{ baseForm.propertyCode }}
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="20" class="flex">
					<span class="label">单位简介：</span>
					{{ baseForm.introduction }}
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="20" class="flex">
					<span class="label">经验范围：</span>
					{{ baseForm.businessScope }}
				</el-col>
			</el-row>
			<p class="divider"></p>
			<el-row>
				<el-col :span="20">
					<span class="label">开户银行：</span>
					{{ bankForm.depositBank }}
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<span class="label">账户名：</span>
					{{ bankForm.accountName }}
				</el-col>
				<el-col :span="10">
					<span class="label">账户号：</span>
					{{ bankForm.accountNo }}
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<span class="label">公司网站：</span>
					{{ bankForm.webSite }}
				</el-col>
				<el-col :span="10">
					<span class="label">电子邮箱：</span>
					{{ bankForm.email }}
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<span class="label">联系人：</span>
					{{ bankForm.contactUser }}
				</el-col>
				<el-col :span="10">
					<span class="label">联系电话：</span>
					{{ bankForm.phone }}
				</el-col>
			</el-row>
		</template>
		<!-- 证照信息 -->
		<template v-if="currentTab === '1'">
			<template v-for="(obj, curIndex) in licenseInfo">
				<el-form
					:ref="`licenseInfo${curIndex}`"
					label-width="110px"
					:model="obj"
					class="show-form"
					size="small"
					:key="curIndex"
					:class="{
						'form-bottom': curIndex !== licenseInfo.length - 1
					}"
					:show-message="false"
				>
					<el-row :gutter="20">
						<el-col :span="6" class="left-width">
							<el-form-item label="证照附件" class="upload-form-item" label-width="0">
								<div class="form-upload">
									<new-upload
										:ref="`cardUpload${curIndex}`"
										tableName="sys_tenant_license"
										:assortment="`licenseInfo`"
										:aid="obj.id"
										forDatabase="user_tenent_center"
										:isDisabled="true"
										:acceptType="picType"
										:maxNum="1"
									></new-upload>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="16" class="right-upload-info">
							<el-row :gutter="20">
								<el-col :span="12">
									<span class="label">企业证照类型：</span>
									{{ obj.licenseName }}
								</el-col>
								<el-col :span="12">
									<span class="label">证照编号：</span>
									{{ obj.licenseNo }}
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12" class="flex">
									<span class="label">工商注册地：</span>
									{{ obj.domicile }}
								</el-col>
								<el-col :span="12">
									<span class="label">发证机构名称：</span>
									{{ obj.orgName }}
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12">
									<span class="label">批注日期：</span>
									{{ obj.postilDate | timeFilter }}
								</el-col>
								<el-col :span="12">
									<span class="label">有效期至：</span>
									{{ obj.indate | timeFilter }}
								</el-col>
							</el-row>
						</el-col>
					</el-row>
				</el-form>
			</template>
		</template>
		<!-- 证明材料 -->
		<template v-if="currentTab === '2'">
			<template v-for="(obj, curIndex) in licenseMaterial">
				<el-form
					:ref="`licenseMaterial${curIndex}`"
					label-width="110px"
					:model="obj"
					class="show-form"
					:key="curIndex"
					size="small"
					:show-message="false"
				>
					<el-row :gutter="20">
						<el-col :span="6" class="left-width">
							<el-form-item label="证明材料附件" class="upload-form-item" label-width="0">
								<div class="form-upload">
									<new-upload
										:ref="`materialUpload${curIndex}`"
										tableName="sys_tenant_evidentiary"
										:assortment="`material`"
										forDatabase="user_tenent_center"
										:aid="obj.id"
										:acceptType="picType"
										:isDisabled="true"
										:maxNum="1"
									></new-upload>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="16" class="right-upload-info">
							<el-row :gutter="20">
								<el-col :span="24">
									<span class="label">证明材料名称：</span>
									{{ obj.sname }}
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="24">
									<span class="label">证明材料类别：</span>
									{{ obj.fileName }}
								</el-col>
							</el-row>
						</el-col>
					</el-row>
				</el-form>
			</template>
		</template>
		<!-- 财务状况 -->
		<template v-if="currentTab === '3'">
			<template v-for="(obj, curIndex) in finance">
				<el-form :ref="`finance${curIndex}`" label-width="140px" :model="obj" :key="curIndex" :show-message="false">
					<el-row :gutter="20">
						<el-col :span="6" class="left-width">
							<el-form-item label="报表附件" class="upload-form-item pdl0" label-width="0">
								<my-upload
									:ref="`financeUpload${curIndex}`"
									tableName="sys_tenant_finance"
									:assortment="`finance`"
									forDatabase="user_tenent_center"
									mode="view"
									:aid="obj.id"
								></my-upload>
							</el-form-item>
						</el-col>
						<el-col :span="16">
							<el-row :gutter="20">
								<el-col :span="12">
									<span class="label">年度汇集报表：</span>
									{{ obj.report }}
								</el-col>
								<el-col :span="12">
									<span class="label">是否经会计事务所审计：</span>
									{{ obj.requireAudit === 1 ? '是' : '否' }}
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12">
									<span class="label">资产负债表(负债率)：</span>
									{{ obj.debtRatio !== null ? obj.debtRatio + ' %' : '' }}
								</el-col>
								<el-col :span="12">
									<span class="label">资产负债表负债总额：</span>
									{{ obj.totalLiability !== null ? obj.totalLiability + ' 万元' : '' }}
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12">
									<span class="label">资产负债表资产总额：</span>
									{{ obj.totalAssets !== null ? obj.totalAssets + ' 万元' : '' }}
								</el-col>
								<el-col :span="12">
									<span class="label">损益表销售收入：</span>
									{{ obj.salesRevenue !== null ? obj.salesRevenue + ' 万元' : '' }}
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12">
									<span class="label">损益表销售税金及附加：</span>
									{{ obj.taxes !== null ? obj.taxes + ' 万元' : '' }}
								</el-col>
								<el-col :span="12">
									<span class="label">损益表利润总额：</span>
									{{ obj.totalProfit !== null ? obj.totalProfit + ' 万元' : '' }}
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12">
									<span class="label">损益表净利润：</span>
									{{ obj.retainedProfit !== null ? obj.retainedProfit + ' 万元' : '' }}
								</el-col>
								<el-col :span="12">
									<span class="label">损益表所得税：</span>
									{{ obj.incomeTax !== null ? obj.incomeTax + ' 万元' : '' }}
								</el-col>
							</el-row>
						</el-col>
					</el-row>
				</el-form>
			</template>
		</template>
		<!-- 资质信息 -->
		<template v-if="currentTab === '4'">
			<template v-for="(obj, curIndex) in aptitudes">
				<el-form :ref="`aptitudes${curIndex}`" label-width="110px" :model="obj" :key="curIndex" :show-message="false">
					<el-row :gutter="20">
						<el-col :span="6" class="left-width">
							<el-form-item label="附件" class="upload-form-item" label-width="0">
								<div class="form-upload">
									<new-upload
										:ref="`aptitudesUpload${curIndex}`"
										tableName="sys_tenant_qualification"
										:assortment="`aptitudes`"
										forDatabase="user_tenent_center"
										:aid="obj.id"
										:isDisabled="true"
										:maxNum="1"
										:acceptType="picType"
									></new-upload>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="16">
							<el-row :gutter="20">
								<el-col :span="12">
									<span class="label">资质序列：</span>
									{{ obj.sequenceName }}
								</el-col>
								<el-col :span="12">
									<span class="label">资质行业：</span>
									{{ obj.industryName }}
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12">
									<span class="label">资质专业：</span>
									{{ obj.professionalName }}
								</el-col>
								<el-col :span="12">
									<span class="label">资质等级：</span>
									{{ obj.grade }}
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12">
									<span class="label">资质证书编号：</span>
									{{ obj.certificateNo }}
								</el-col>
								<el-col :span="12">
									<span class="label">发证机关：</span>
									{{ obj.orgName }}
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12">
									<span class="label">发证日期：</span>
									{{ obj.issueDate | timeFilter }}
								</el-col>
								<el-col :span="12">
									<span class="label">有效起始日期：</span>
									{{ obj.indateStart | timeFilter }}
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12">
									<span class="label">有效截止日期：</span>
									{{ obj.indateEnd | timeFilter }}
								</el-col>
							</el-row>
						</el-col>
					</el-row>
				</el-form>
			</template>
		</template>
		<!-- 项目案例 -->
		<template v-if="currentTab === '5'">
			<template v-for="(item, curIndex) of projectList">
				<div :key="curIndex" class="project">
					<el-row>
						<el-col :span="24">
							<span class="label">项目名称：</span>
							{{ item.project }}
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<span class="label">项目单位：</span>
							{{ item.company }}
						</el-col>
						<el-col :span="12">
							<span class="label">项目来源：</span>
							{{ item.proSource }}
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<span class="label">项目时间：</span>
							{{ item.startTime | timeFilter }}~{{ item.endTime | timeFilter }}
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<span class="label">项目地址：</span>
							{{ item.areaName }}
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<span class="label">详细地址：</span>
							{{ item.proAdd }}
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24" class="flex">
							<span class="label">项目描述：</span>
							<span class="inlineBlock">{{ item.projectDes }}</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24" class="flex">
							<span class="projectLabel">项目图片：</span>
							<div class="form-upload">
								<public-upload
									:ref="`projectUpload${curIndex}`"
									tableName="sys_tenant_case"
									:assortment="`projectCase`"
									:aid="item.id"
									:isDisabled="true"
									forDatabase="user_tenent_center"
									:acceptType="picType"
									listType="picture-card"
								></public-upload>
							</div>
						</el-col>
					</el-row>
				</div>
			</template>
		</template>
		<!-- 组织人员 -->
		<template v-if="currentTab === '6'">
			<w-split v-model="splitV" class="min-tree">
				<div slot="left" class="split-pane">
					<div class="left-container tree-layout">
						<h3 class="top-header font-14">组织架构</h3>
						<el-tree
							:data="organizeList"
							node-key="id"
							ref="organizeTree"
							default-expand-all
							@node-click="handleNodeClick"
							:expand-on-click-node="false"
						>
							<span class="custom-tree-node" slot-scope="{ data }">
								<span class="font-12 text-overflow pdr5">{{ data.sname }}</span>
							</span>
						</el-tree>
					</div>
				</div>
				<div slot="right" class="h100 pdl10 right-box">
					<el-tabs v-model="orgActiveTab" @tab-click="onOrgTabClick">
						<el-tab-pane label="企业组织人员" name="people">
							<h3 class="top-header font-14">组织： {{ curTreeName }}</h3>
							<div class="org-table-wrap">
								<el-table
									border
									:data="firstTable.tableData"
									size="mini"
									height="360px"
									class="organize-table"
									highlight-current-row
									highlight-hover-row
									key="table1"
								>
									<el-table-column type="index" label="序号" width="55px" show-overflow-tooltip align="center"></el-table-column>
									<el-table-column prop="sname" label="姓名" width="100" align="center" show-overflow-tooltip></el-table-column>
									<el-table-column prop="idCard" label="身份证号" width="160" align="center"></el-table-column>
									<el-table-column prop="phone" label="手机号" width="120" align="center"></el-table-column>
									<el-table-column
										prop="orgName"
										label="组织"
										min-width="150"
										show-overflow-tooltip
										align="center"
									></el-table-column>
									<el-table-column prop="openSysName" label="创建人身份" width="110" align="center">
										<template slot-scope="scope">
											<div>
												{{ dealIdentity(scope.row.isAdmin) }}
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="createDate" label="创建时间" width="165" align="center"></el-table-column>
								</el-table>
								<div class="org-table-page">
									<el-pagination
										@size-change="handleSizeChange($event, 'first')"
										@current-change="handleCurrentChange($event, 'first')"
										:current-page="firstTable.current"
										:page-sizes="firstTable.pageList"
										:page-size="firstTable.pageSize"
										layout="total, sizes, prev, pager, next, jumper"
										:total="firstTable.total"
										size="mini"
									>
									</el-pagination>
								</div>
							</div>
						</el-tab-pane>
						<el-tab-pane label="人员变更记录" name="record">
							<div class="org-table-wrap">
								<el-table
									border
									:data="transTable.tableData"
									size="mini"
									height="360px"
									highlight-current-row
									highlight-hover-row
									key="tableTrans"
								>
									<el-table-column type="index" label="序号" width="55px" show-overflow-tooltip align="center"></el-table-column>
									<el-table-column prop="changeType" label="变更类型" min-width="110" align="center" show-overflow-tooltip>
										<template slot-scope="scope">
											{{ scope.row.changeType == 0 ? '企业主转让' : scope.row.changeType == 1 ? '人员退出' : '' }}
										</template>
									</el-table-column>
									<el-table-column prop="alienator" label="转让/退出人" min-width="110" align="center" show-overflow-tooltip></el-table-column>
									<el-table-column prop="aliNo" label="转让/退出人身份证号" min-width="170" align="center" show-overflow-tooltip></el-table-column>
									<el-table-column prop="aliPhone" label="转让/退出人手机号" min-width="130" align="center" show-overflow-tooltip></el-table-column>
									<el-table-column prop="transfee" label="被转让人" min-width="110" align="center" show-overflow-tooltip></el-table-column>
									<el-table-column prop="transNo" label="被转让人身份证号" min-width="170" align="center" show-overflow-tooltip></el-table-column>
									<el-table-column prop="transPhone" label="被转让人手机号" min-width="130" align="center" show-overflow-tooltip></el-table-column>
									<el-table-column prop="createDate" label="转让/退出时间" min-width="160" align="center" show-overflow-tooltip></el-table-column>
								</el-table>
								<div class="org-table-page">
									<el-pagination
										@size-change="handleTransSizeChange"
										@current-change="handleTransCurrentChange"
										:current-page="transTable.current"
										:page-sizes="transTable.pageList"
										:page-size="transTable.pageSize"
										layout="total, sizes, prev, pager, next, jumper"
										:total="transTable.total"
										size="mini"
									>
									</el-pagination>
								</div>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>
			</w-split>
		</template>
		<!-- 业务板块负责人 -->
		<template v-if="currentTab === '7'">
			<el-table border :data="personData" size="small" highlight-current-row highlight-hover-row>
				<el-table-column type="index" label="序号" width="60px" show-overflow-tooltip align="center"></el-table-column>
				<el-table-column prop="业务板块" label="业务板块" min-width="200" align="center" show-overflow-tooltip>
					<template>
						<span>安招采·电子招投标交易系统</span>
					</template>
				</el-table-column>
				<el-table-column prop="mainTypeName" label="业务角色" width="200" align="center"></el-table-column>
				<el-table-column prop="sname" label="负责人" width="150" align="center"></el-table-column>
				<el-table-column prop="idCard" label="身份证号" width="220" show-overflow-tooltip align="center"></el-table-column>
				<el-table-column prop="phone" label="手机号" width="160" align="center"> </el-table-column>
			</el-table>
		</template>
	</div>
</template>

<script>
import newUpload from 'components/upload/newUpload'
import * as Api from 'api/modules/enterprises_new'

export default {
	name: 'tab-content',
	components: {
		newUpload
	},
	props: {
		// 当前tab 页
		currentTab: {
			type: String,
			default: '0'
		},
		// 当前 tab 页数据
		tabData: {
			type: Array | Object,
			default: () => {
				return []
			}
		}
	},
	filters: {
		timeFilter(val) {
			if (val) {
				return val.slice(0, 10)
			} else {
				return ''
			}
		}
	},
	data() {
		return {
			// 基础信息tab
			baseForm: {},
			bankForm: {},
			// 证照信息
			licenseInfo: [{}],
			// 证明材料信息
			licenseMaterial: [{}],
			// 财务状况
			finance: [{}],
			// 资质信息
			aptitudes: [{}],
			// 组织人员
			splitV: 0.3,
			orgActiveTab: 'people', // people: 企业组织人员; record: 人员变更记录
			organizeList: [], // 左侧树
			curTreeName: '', // 当前选中的树节点名称
			parentId: '',
			curOrgId: '',
			firstTable: {
				queryField: '',
				tableData: [],
				pageSize: 10,
				current: 1,
				total: 0,
				pageList: [10, 20, 50, 100]
			},
			transTable: {
				tableData: [],
				pageSize: 10,
				current: 1,
				total: 0,
				pageList: [10, 20, 50, 100]
			},
			// 业务板块负责人
			personData: [],
			//   项目案例
			projectList: []
		}
	},
	created() {
		// 解决tabData undefined 的问题
		this.$nextTick(() => {
			if (this.currentTab == 0 && this.tabData) {
				this.getBase()
			}
		})
	},
	methods: {
		// 右侧子 tab 切换
		onOrgTabClick(tab) {
			if (tab.name === 'record') {
				this.transTable.current = 1
				this.getTransList()
			}
		},

		// 查询人员变更记录
		getTransList() {
			Api.getPageTrans({
				size: this.transTable.pageSize,
				current: this.transTable.current,
				tenantId: this.$route.query.tenantId
			})
				.then((res) => {
					this.transTable.tableData = (res.data && res.data.records) || []
					this.transTable.total = parseInt((res.data && res.data.total) || 0)
				})
				.catch(() => {
					this.transTable.tableData = []
					this.transTable.total = 0
				})
		},

		// 人员变更记录 切换显示条数
		handleTransSizeChange(size) {
			this.transTable.pageSize = size
			this.getTransList()
		},

		// 人员变更记录 切换当前页码
		handleTransCurrentChange(cur) {
			this.transTable.current = cur
			this.getTransList()
		},

		// 组织人员 左侧树结构  点击
		handleNodeClick(row, node) {
			if (!row) return
			let _rootName = this.organizeList[0].sname || ''
			let _parentName = (node && node.parent && node.parent.data && node.parent.data.sname) || ''
			this.curOrgId = row.id
			if (!node || node.level === 1) {
				this.curTreeName = _rootName
			} else if (node.level === 2) {
				this.curTreeName = _rootName + ' > ' + row.sname
			} else {
				this.curTreeName = _rootName + ' > ' + _parentName + ' > ' + row.sname
			}
			// 查询对应的 组织下面的人员
			if (this.orgActiveTab === 'people') {
				this.doSearch()
			}
		},

		// 查询组织下的人员
		doSearch(data) {
			Api.getAllUser({
				size: this.firstTable.pageSize,
				current: this.firstTable.current,
				orgId: data === 'all' ? this.parentId : this.curOrgId, // 组织架构ID
				tenantId: this.$route.query.tenantId,
				sname: this.firstTable.queryField
			})
				.then((res) => {
					this.firstTable.tableData = res.data.records
					this.firstTable.total = parseInt(res.data.total)
				})
				.catch((err) => {
					this.firstTable.tableData = []
					this.firstTable.total = 0
				})
		},

		// 处理人员企业身份
		dealIdentity(data) {
			let name = ''
			switch (data) {
				case 0:
					name = '企业成员'
					break
				case 1:
					name = '企业主'
					break
				case 2:
					name = '企业管理员'
					break
			}
			return name
		},

		// 表格 切换显示条数
		handleSizeChange(size, type) {
			this.firstTable.pageSize = size
			this.doSearch()
		},

		// 表格 切换当前页码
		handleCurrentChange(cur, type) {
			this.firstTable.current = cur
			this.doSearch()
		},
		getBase() {
			this.baseForm = this.tabData
			this.bankForm = this.tabData
		}
	},
	computed: {
		// 图片类型限制 --- 附件
		picType() {
			return ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'GIF', 'JPG', 'PNG']
		}
	},
	watch: {
		tabData: {
			handler: function(data) {
				switch (parseInt(this.currentTab)) {
					// 基本信息
					case 0:
						this.baseForm = data
						this.bankForm = data
						break
					// 证照信息
					case 1:
						this.licenseInfo = data
						break
					// 证明材料
					case 2:
						this.licenseMaterial = data
						break
					// 财务状况
					case 3:
						this.finance = data
						break
					// 资质信息
					case 4:
						this.aptitudes = data
						break
					// 项目案例
					case 5:
						this.projectList = data
						break
					// 组织架构
					case 6:
						this.orgActiveTab = 'people'
						this.organizeList = data
						if (data && data.length > 0) {
							this.parentId = data[0].id
							setTimeout(() => {
								let node = this.$refs.organizeTree && this.$refs.organizeTree.getNode(data[0].id)
								this.handleNodeClick(data[0], node)
								if (this.$refs.organizeTree) {
									this.$refs.organizeTree.setCurrentKey(data[0].id)
								}
							}, 100)
						}
						break
					// 业务板块负责人
					case 7:
						this.personData = data
						break
				}
			},
			deep: true
		}
	}
}
</script>

<style scoped lang="less">
.content-main {
	color: #000;
	line-height: 30px;
	font-size: 14px;

	.divider {
		border-bottom: 1px dashed #ccc;
		height: 0;
		margin: 10px 0;
	}

	.form-bottom {
		border-bottom: 1px dashed #dcdfe6;
		padding-bottom: 20px;
		margin-bottom: 20px;
	}

	.label {
		color: #666;
		flex-shrink: 0;
	}

	/* 附件 */

	.form-upload {
		height: 120px;
		display: inline-block;
	}

	.upload-form-item {
		height: 160px;

		/deep/ .el-form-item__label {
			width: 100% !important;
			text-align: left;
			padding-left: 20px;
		}

		/deep/ .el-form-item__content {
			margin-top: 30px;
		}
	}

	.right-upload-info {
		padding-top: 25px;
	}

	.min-tree {
		min-height: 540px;
		overflow: visible;
	}

	.right-box {
		overflow: visible;

		/deep/ .el-tabs__content {
			overflow: visible;
		}

		/deep/ .el-tab-pane {
			overflow: visible;
		}
	}

	.org-table-wrap {
		.org-table-page {
			margin-top: 30px;
			padding: 5px 0;
			text-align: center;
		}
	}

	.project {
		border-bottom: 1px dashed #ccc;
		padding-bottom: 20px;
		margin-top: 20px;
	}
}
</style>
